import { Recordatorio } from '../../domain/entities/Recordatorio';
import { RecordatorioRepository } from '../../domain/repositories/RecordatorioRepository';
import { ApiClient } from '../api/ApiClient';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  timestamp: string;
}

export class ApiRecordatorioRepository implements RecordatorioRepository {
  private apiClient: ApiClient;

  constructor() {
    this.apiClient = new ApiClient();
  }

  async findByNumero(nroRecordatorio: number): Promise<Recordatorio | null> {
    try {
      const response = await this.apiClient.get<ApiResponse<Recordatorio>>(
        `ConsultarRecordatorio/${nroRecordatorio}`
      );
      if (response && response.success && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error(`Error al buscar recordatorio ${nroRecordatorio}:`, error);
      return null;
    }
  }

  async registerPayment(data: {
    uuid: string;
    nroRecordatorio: number;
    valorPagado: number;
    identificacion: string;
    estado: string;
    fechaPago: string;
    medioPago: string;
    nombreCliente?: string;
    codigoFideicomiso?: number;
    oficina?: number;
    id?: number;
    intereses?: number;
    detalleFactura?: string;
    fechaFactura?: string;
    valorTotal?: number;
    valorSaldo?: number;
  }): Promise<{ id: number }> {
    try {
      const response = await this.apiClient.post<ApiResponse<{ message: string; id: number }>>(
        'RegistrarPagoRecordatorio',
        data
      );
      return { id: response.data?.id || 0 };
    } catch (error) {
      console.error('Error al registrar pago de recordatorio:', error);
      throw new Error('Error al registrar el pago del recordatorio');
    }
  }
}
